import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'lui-nav-list',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class NavListComponent {
  @HostBinding('class') hostClass = 'lui-nav-list';
}
